export enum BookingDetailsDataHook {
  SERVICE_NAME = 'booking-details-service-name',
  ACTION_BUTTON = 'booking-details-action-button',
}
